import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import Alert from '@mui/material/Alert';
import styled from '@mui/material/styles/styled';
import { SxProps } from '@mui/material';

export interface TwAlertsProps {
  /**
   * The alert message to show the user.
   */
  message: string;
  severity?: 'error' | 'info' | 'success' | 'warning';
  icon?: React.ReactNode;
  sx?: SxProps;
  action?: React.ReactNode;
}

const StyledAlert = styled(Alert)(() => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  minHeight: '44px',
  marginBottom: '8px',
  color: '#171E28',

  '& .MuiAlert-icon': {
    padding: '5px 0'
  }
}));

const TwAlert: React.FC<TwAlertsProps> = ({
  message,
  sx,
  action,
  severity = 'error',
  icon = <CancelIcon sx={{ fill: '#EA5356' }} />
}): JSX.Element => {
  return (
    <StyledAlert severity={severity} icon={icon} className="tid-alert" sx={sx} action={action}>
      {message}
    </StyledAlert>
  );
};

export default TwAlert;
